
import { defineComponent, reactive } from 'vue'
import { useAuditLogsModule } from '@/modules/audit-logs'
import AuditLogsFilter from '@/components/audit-logs/audit-logs-filter.vue'
import AuditLogsList from '@/components/audit-logs/audit-logs-list.vue'

export default defineComponent({
    name: 'view-audit-logs',
    components: {
        AuditLogsFilter,
        AuditLogsList
    },
    async setup () {
        const { getAuditLogs, auditLogs } = useAuditLogsModule()

        const filter = reactive({
            search: '',
            id: '',
            operatorName: '',
            operatorOrigin: '',
            action: '',
            requestId: '',
            occurrence: ''
        })

        function onResetFilters () {
            filter.search = ''
            filter.id = ''
            filter.operatorName = ''
            filter.operatorOrigin = ''
            filter.action = ''
            filter.requestId = ''
            filter.occurrence = ''
        }

        await getAuditLogs()

        return {
            auditLogs,
            filter,
            onResetFilters
        }
    }
})
